export const round = (num, precision = 2) => {
  return Number(Math.round(num + `e+${precision}`) + `e-${precision}`)
}
